import type { ModelMessage, ToolSet } from 'ai';
import type { Ty } from '@cotera/era';
import type {
  LLMInput,
  LlmCallSettings,
  LlmProviderOptions,
} from './llm-input-types';

export type ModelInputDraft = {
  messages: ModelMessage[];
  system?: string;
  /** AI SDK tools from {@link LLMInputBuilder.withTools} (inline schemas, not tool keys). */
  toolSet?: ToolSet;
  baseCallSettings?: LlmCallSettings;
  /** Pre-built streamText `output`; overrides {@link outputShape} when set. */
  streamTextOutput?: LLMInput['output'];
  /**
   * Era output type for single-pass structured output. Resolved at
   * {@link LLMInputBuilder.build} via the selected {@link ModelInputAdapter}.
   */
  outputShape?: Ty.ExtendedAttributeType;
};

export function mergeProviderOptions(
  base: LlmProviderOptions | undefined,
  patch: LlmProviderOptions | undefined
): LlmProviderOptions | undefined {
  if (base === undefined && patch === undefined) {
    return undefined;
  }
  const merged: LlmProviderOptions = { ...base };
  if (patch !== undefined) {
    for (const [provider, value] of Object.entries(patch)) {
      merged[provider] = {
        ...(merged[provider] as object | undefined),
        ...(value as object),
      };
    }
  }
  return merged;
}
